<template>
  <a-modal style="text-align: center" width="800px" v-model:visible="props.visible" :title="user.buildName"
           @ok="handleOk" :footer="null" @cancel="emit('showMap',false)">
    <a-descriptions :column="2">
      <a-descriptions-item label="查找">
        <a-input-search v-model:value="value" style="width: 220px;" allow-clear placeholder="输入二维码或设备Id"
                        @search="onSearch"/>
      </a-descriptions-item>
    </a-descriptions>
    <a-spin :spinning="initMapFlag" tip="地图加载中...">
      <div id='indexMap'>
        <div class='map-floor-group'>
          <div class='floorUp floor_btn'>
            <UpOutlined style="cursor: pointer"/>
          </div>
          <div class='scroll'>
            <ul></ul>
          </div>
          <div class='floorDown floor_btn'>
            <down-outlined style="cursor: pointer"/>
          </div>
        </div>
        <a-tooltip class='item'
                   effect='dark'
                   content='地图居中'
                   placement='top'>
          <div class='mapCenter' @click="mapCenter">
            <img src='@/assets/image/mapCenter.png'
                 alt=''>
          </div>
        </a-tooltip>
      </div>
    </a-spin>
  </a-modal>
</template>
<script setup>
import {onMounted, onUnmounted, ref} from "vue";
import bfMap from "@/assets/js/bfmap-app2";
import {UpOutlined, DownOutlined} from "@ant-design/icons-vue"
import userStore from "@/stores/user";
import devStore from "@/stores/devStore";
import singleStore from "@/stores/singleDev";
import load from "@/common/load";

let dev = devStore();
let user = userStore();
let single = singleStore();

let value = ref('');
let props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  floorId: {
    type: String,
    default: "LX01"
  }
});
onMounted(() => {
  bfMap.initMap('indexMap', user.buildId, function () {
    // 注册图片
    bfMap.loadImage('https://www.beefindtech.com/map/gosAPP/image/cover.png', 'cover');
    // 切换楼层回调
    bfMap.changeFloor(function () {
      initMapFlag.value = true;
      loadMainSubQuery();
      if (bfMap.locationPopup) {
        bfMap.locationPopup.remove();
      }
    });
    //  加载设备图标
    loadMainSubQuery();
    if (props.floorId) {
      let time = setInterval(() => {
        if (bfMap.map.getLayer(props.floorId + '-park-layer')) {
          clearInterval(time)
          bfMap.dynamicChageFloor(props.floorId, function () {
            loadMainSubQuery();
          })
        }
      }, 100)
    }
  })

})
let emit = defineEmits(['showMap'])
const handleOk = () => {
  emit('showMap', false);
};

// 判断是否是4326 还是3857
const detectCoordinateSystem = (x, y) => {
  const WEB_MERCATOR_MAX = 20026376;
  const WEB_MERCATOR_MIN = -20026376;

  return x < WEB_MERCATOR_MIN || x > WEB_MERCATOR_MAX ||
      y < WEB_MERCATOR_MIN || y > WEB_MERCATOR_MAX;
};

let initMapFlag = ref(true);
let loadMainSubQuery = async () => {
  console.log(dev.shootCameras)
  console.log(dev.shootParkError)
  let mapData = [];
  for (let shootCamerasKey in dev.shootCameras) {
    if (shootCamerasKey === bfMap.currentFloorId) {
      dev.shootCameras[shootCamerasKey].forEach(item => {
        item.data.point = [Number(item.data.deviceX), Number(item.data.deviceY)];
        if (!detectCoordinateSystem(Number(item.data.deviceX), Number(item.data.deviceY))) {
          item.data.point = bfMap.webMercator2LngLat(item.data.point);
        }
        item.data.pointX = item.data.point[0];
        item.data.pointY = item.data.point[1];
        item.data.img = 'cover';
        item.data.imgSize = 0.5;
        item.data.imgColor = "#b2b2b2";
        bfMap.floorDataArr.forEach(floor => {
          if (floor.floorID === bfMap.currentFloorId && dev.shootParkError[floor.floorID].data.size) {
            if (dev.shootParkError[floor.floorID].data.has(item.data.deviceId)) {
              item.data.imgColor = "#f1f";
            }
          }
        })
        mapData.push({...item.data});
      });
      console.log(mapData)
      bfMap.crawDevLayer(bfMap.currentFloorId + '-marker', mapData, 'visible');
      bfMap.crawCircleLayer(mapData, bfMap.currentFloorId + '-circle', 'visible', bfMap.currentFloorId + '-marker');
      initMapFlag.value = false;
      // 图标点击事件
      bfMap.on('click', function (e) {
        let clickLayerId = '';
        let data = {};
        if (e.features.length > 0) {
          clickLayerId = e.features[0].layer.id.split(bfMap.currentFloorId)[1];
          data = e.features[0].properties;
        }
        data.lngLat = e.lngLat;
        bfMap.map.flyTo({center: e.lngLat});
        showMode(clickLayerId, data);
      });
    }
  }
};
let onSearch = () => {
  if (value.value) {
    for (let shootCamerasKey in dev.shootCameras) {
      dev.shootCameras[shootCamerasKey].forEach(item => {
        if (item.data.uniqueCode === value.value || item.data.deviceId === value.value) {
          if (shootCamerasKey !== bfMap.currentFloorId) {
            load.loading("已找到，正在切换楼层");
            bfMap.dynamicChageFloor(shootCamerasKey, async function () {
              await loadMainSubQuery();
              showMode('-marker', item.data);
            })
          }
          showMode('-marker', item.data);
        }
      })
    }
  }
}
// 设备点击弹窗
let showMode = (id, data) => {
  if (!data.pointX) {
    return;
  }
  if (bfMap.locationPopup) {
    bfMap.locationPopup.remove();
  }
  console.log(id)
  console.log(data)
  let html = "";
  if (id === '-marker') {
    html = `
        <p>二维码：<u style="color: rgb(12, 22, 234);cursor: pointer;" id="changeCode">${data.uniqueCode}</u></p>
        <p>老版本页面：<u style="color: rgb(12, 22, 234);cursor: pointer;" id="openOldMenu">${data.uniqueCode}</u></p>
        <p>设备id：${data.deviceId}</p>
        <p>在线状态：${data.online === 1 ? '在线' : '掉线'}</p>
        <p>主副状态：${data.netType === 'main' ? '主节点' : '辅节点'}</p>
        <p>主节点二维码：<u style="color: rgb(12, 22, 234);cursor: pointer;" id="masternodeQRCode">${data.netName}</u></p>
        <p>老版本主节点页面：<u style="color: rgb(12, 22, 234);cursor: pointer;" id="openOldQRCode">${data.netName}</u></p>
      `
  } else if (id === '-park-layer') {
    html = `<p>车位号：${data.parknum}</p>`

  }
  if (html) {
    let point = [data.pointX, data.pointY];
    bfMap.locationPopup = bfMap.createPopup(point, html);
    bfMap.map.flyTo({center: point});
  }
  /* eslint-disable */
  $("#openOldMenu").on('click', function () {
    window.open(`http://cn.beefindtech.cn/subservice/mqtt_new/gos8.html?${data.uniqueCode}`)
  })
  $("#openOldQRCode").on('click',function () {
    window.open(`http://cn.beefindtech.cn/subservice/mqtt_new/gos8.html?${data.netName}`)
  })
  function changeCode(code) {
    let data = dev.devListInfo.deviceList.filter(item => {
      return item.floorId === bfMap.currentFloorId;
    })
    single.changeCurrentCode(code, data[0].devices);
    emit('showMap', false);
  }

  /* eslint-disable */
  $('#changeCode').on('click', function () {
    changeCode($('#changeCode').text())
  })
  $('#masternodeQRCode').on('click', function () {
    changeCode($('#masternodeQRCode').text())
  })
}

onUnmounted(() => {
  bfMap.initMapFlag = false;
  bfMap.currentFloorId = "";
})
let mapCenter = () => {
  bfMap.setMapCenter(bfMap.currentFloorId);
}
</script>
<style scoped lang="scss">
#indexMap {
  margin-top: 20px;
  height: 530px;
}
</style>
<style lang="scss">
#indexMap {
  .mapboxgl-popup-close-button {
    display: none;
  }

  .active {
    background: #409EFF;
    color: #fff
  }

  .map-floor-group > .scroll > ul > li {
    cursor: pointer;
    width: 30px;
    height: 30px;
    font-size: 13px;
    border-radius: 50%;
    position: relative;
    margin: 0 auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    font-weight: 700;
  }

  .mapCenter {
    width: 40px;
    position: absolute;
    right: 32px;
    top: 65%;
    z-index: 999;
    cursor: pointer;
  }

  .proCheck {
    width: 100px;
    position: absolute;
    right: 44px;
    top: 45px;
    z-index: 999;
    background: #fff;
    opacity: .8;
    padding: 5px 0 0 5px;
    color: white;
    display: flex;
    flex-direction: column;
  }

  .mapCenter img {
    width: 100%;
  }

  ul {
    list-style: none;
    padding: 0;
  }

  .map-floor-group {
    -webkit-box-shadow: 0 0 0.1rem hsla(0, 0%, 80%, 0.8);
    box-shadow: 0 0 0.1rem hsla(0, 0%, 80%, 0.8);
    border-radius: 22px;
    background-color: #fff;
    text-align: center;
    color: #464c5b;
    position: absolute;
    -webkit-transition: all .5s;
    transition: all .5s;
    right: 30px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    padding: 8px;
    z-index: 99999;
  }

  .map-floor-group > .floor_btn.off {
    color: #eee
  }

  .map-floor-group > .scroll {
    position: relative
  }

  .map-floor-group > .scroll > ul {
    overflow: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    position: relative;
    margin: 0;
  }
}
</style>
